"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BookOpenSolid: function() {
        return BookOpenSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const BookOpenSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M11 3.93579C9.79474 3.33693 8.43609 3 7 3C4.87259 3 2.91514 3.73938 1.37453 4.97438C1.13777 5.16417 1 5.45119 1 5.75463V20.0046C1 20.3892 1.22055 20.7397 1.56726 20.9061C1.91397 21.0726 2.3254 21.0254 2.62547 20.7849C3.82406 19.8241 5.34362 19.25 7 19.25C8.48833 19.25 9.8662 19.7135 11 20.5046V3.93579Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M13 20.5046C14.1338 19.7135 15.5117 19.25 17 19.25C18.6564 19.25 20.1759 19.8241 21.3745 20.7849C21.6746 21.0254 22.086 21.0726 22.4327 20.9061C22.7795 20.7397 23 20.3892 23 20.0046V5.75463C23 5.45119 22.8622 5.16417 22.6255 4.97438C21.0849 3.73938 19.1274 3 17 3C15.5639 3 14.2053 3.33693 13 3.93579V20.5046Z",
            fill: "currentColor"
        })
    ]
}), "BookOpenSolid");
const _default = BookOpenSolid;
